<template>
    <div @mousemove="doMouse" class="w-screen relative flex flex-col">
        <Head :title="page?.page_title" />
        <Navigation class="!z-[120] pointer-events-auto" :auth="auth" />
        <!-- <div v-if="auth?.user" class=" absolute bg-slate-800 text-white w-1/3 top-16 left-36 z-[300] text-left">{{ windowSize }} -- {{ size }} {{ mousing }} {{ mouseHideOverride }}</div> -->
        <main class="absolute top-0 left-0 z-10 pointer-events-auto mx-auto flex flex-wrap justify-center w-screen min-h-screen h-auto">
        <div :class="['touch-arrow', {'show': showArrow===true}]">
            <vue-feather type="arrow-down" size="76px" />
        </div>
            <!-- wrap the built-in Transition component -->
            <slot></slot> <!-- pass down slot content -->
        </main>
    </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Navigation from '@/components/Navigation.vue';
import { generalStore } from '@/stores/generalStore'
import { mapActions, mapWritableState } from 'pinia';
import dayjs from 'dayjs'

export default {
    name: 'DefaultLayout',
    props: ['auth', 'page', 'sizesFromServer'],
    components: { Head, Navigation },
    computed: {
        ...mapWritableState(generalStore, ['mouseHideOverride', 'mouseTimeout', 'hideNav', 'isTouchDevice', 'mousing', 'windowSize', 'scrollY', 'pageHeight', 'size', 'sizes']),
        year() {
            return dayjs().format('YYYY');
        },
        showArrow() {
            if (typeof window === 'undefined') return false;
            const height=window.screen.height;

            return this.isTouchDevice && (height < (this.pageHeight-250))
                && (parseInt(this.scrollY) < 200) ? true : false;
        }
        // hideNav() {
        //     return this.page?.hide_navigation;
        // }
    },
    watch: {
        mousing() {
            this.doMouseOut()
        },
        '$page': {
            handler(n) {
                setTimeout(() => {
                    window.scrollTo(0,0);
                    this.setPageHeight();
                },240);
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
        }
    },
   unMounted() {
        this.mouseTimeout=null

        window.removeEventListener('scroll', this.doMouse);
        window.removeEventListener('resize', this.resize);
   },
    mounted() {
        this.sizes=this.sizesFromServer;
        this.isTouchDevice=('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch) || false;        setTimeout(() => {

            this.mousing=false;
            this.mouseTimeout=null;
        }, 2000);

        this.resize();
        window.addEventListener('scroll', this.doMouse);
        window.addEventListener('resize', this.resize);
        this.windowSize={w: window.innerWidth, h: window.innerHeight};
   },
   methods: {
        ...mapActions(generalStore, ['startTimeToFade']),
        doMouseOut() {

            this.startTimeToFade();

        },
        doMouse() {
            this.setPageHeight();
            if(!this.isTouchDevice) {
                this.mousing=true;
                this.mouseTimeout=null;
            }
        },
        mouseUp() {

        },
        resize(e) {
            setTimeout(() => {
                this.windowSize={w: window.innerWidth, h: window.innerHeight};
                const w=this.windowSize?.w;
                switch (true) {
                    case w <= 3840 && w > 1920:
                        this.size=this.sizes[0];
                        break;
                    case w <= 1920 && w > 1280:
                    default:
                        this.size=this.sizes[1];
                        break;
                    case w <= 1280 && w > 854:
                        this.size=this.sizes[2];
                        break;
                    case w <= 854 && w > 320:
                        this.size=this.sizes[3];
                        break;
                    case w <= 320 && w > 160:
                        this.size=this.sizes[4];
                        break;
                }
                // this.size=this.sizes[1];
                this.setPageHeight();
            }, 250)


        },
        setPageHeight() {
            let body = document.body,
                html = document.documentElement;
            this.scrollY=window?.scrollY || 1;
            this.pageHeight=Math.max( body.scrollHeight, body.offsetHeight,
                       html.clientHeight, html.scrollHeight, html.offsetHeight );
        }

    }

}

</script>
<style scoped>
footer
{
    width: 130px;
    height: 14px;
    position: fixed;
    bottom: 0px;
    right: 0px;
    padding: 0 10px;
}

nav ul {
    margin: 10px 3px 0;
}
nav ul li .menu-btn {
    color: white;
    padding: 6px 12px 4px;
    background-color: rgba(255,255,255,.5);
}
nav ul li .menu-btn:hover,
nav ul li .menu-btn.active {
    text-decoration: none;
    background-color: rgba(255,255,255,1);
    color: black;
}
.touch-arrow {
    transition: all .5s cubic-bezier(0.215, 0.610, 0.355, 1);
    z-index: 2000;
    @apply fixed bottom-0 right-0 pb-0 sm:pb-12 pr-2 text-gray-200;
    transform: scale(0);
    transform-origin: center top;
    opacity: 0;
}
.touch-arrow.show {
    opacity: .7;
    transform: scale(1);
}
</style>
